var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 92,
	"./layouts/card/style.module.scss": 92,
	"./layouts/components/breadcrumbs": 115,
	"./layouts/components/breadcrumbs/": 115,
	"./layouts/components/breadcrumbs/index": 115,
	"./layouts/components/breadcrumbs/index.tsx": 115,
	"./layouts/components/breadcrumbs/style.module": 168,
	"./layouts/components/breadcrumbs/style.module.scss": 168,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 117,
	"./layouts/components/container/style.module.scss": 117,
	"./layouts/components/footer": 116,
	"./layouts/components/footer/": 116,
	"./layouts/components/footer/index": 116,
	"./layouts/components/footer/index.tsx": 116,
	"./layouts/components/footer/style.module": 83,
	"./layouts/components/footer/style.module.scss": 83,
	"./layouts/components/loading_indicator": 56,
	"./layouts/components/loading_indicator/": 56,
	"./layouts/components/loading_indicator/index": 56,
	"./layouts/components/loading_indicator/index.tsx": 56,
	"./layouts/components/nav_bar": 91,
	"./layouts/components/nav_bar/": 91,
	"./layouts/components/nav_bar/index": 91,
	"./layouts/components/nav_bar/index.tsx": 91,
	"./layouts/components/nav_bar/standalone": 321,
	"./layouts/components/nav_bar/standalone.tsx": 321,
	"./layouts/components/nav_bar/style.module": 33,
	"./layouts/components/nav_bar/style.module.scss": 33,
	"./layouts/components/notice_banner": 82,
	"./layouts/components/notice_banner/": 82,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 169,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 169,
	"./layouts/components/notice_banner/index": 82,
	"./layouts/components/notice_banner/index.tsx": 82,
	"./layouts/components/notice_banner/standalone": 322,
	"./layouts/components/notice_banner/standalone.tsx": 322,
	"./layouts/components/notice_banner/style.module": 170,
	"./layouts/components/notice_banner/style.module.scss": 170,
	"./layouts/page": 88,
	"./layouts/page/": 88,
	"./layouts/page/index": 88,
	"./layouts/page/index.tsx": 88,
	"./layouts/page/style.module": 84,
	"./layouts/page/style.module.scss": 84,
	"./layouts/types": 323,
	"./layouts/types.ts": 323,
	"./marketing/pages/home/ielts": 1596,
	"./marketing/pages/home/ielts/": 1596,
	"./marketing/pages/home/ielts/assets/avatars": 1849,
	"./marketing/pages/home/ielts/assets/avatars.png": 1849,
	"./marketing/pages/home/ielts/index": 1596,
	"./marketing/pages/home/ielts/index.tsx": 1596,
	"./marketing/pages/home/ielts/sections/ai": 1191,
	"./marketing/pages/home/ielts/sections/ai/": 1191,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature": 1824,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature.png": 1824,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature": 1825,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature.png": 1825,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature": 1826,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature.png": 1826,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature": 1827,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature.png": 1827,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg": 1828,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg.svg": 1828,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon": 1829,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon.svg": 1829,
	"./marketing/pages/home/ielts/sections/ai/index": 1191,
	"./marketing/pages/home/ielts/sections/ai/index.tsx": 1191,
	"./marketing/pages/home/ielts/sections/ai/style.module": 1830,
	"./marketing/pages/home/ielts/sections/ai/style.module.scss": 1830,
	"./marketing/pages/home/ielts/sections/apps": 1192,
	"./marketing/pages/home/ielts/sections/apps/": 1192,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon": 1831,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon.svg": 1831,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon": 1832,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon.svg": 1832,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app": 1833,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app.png": 1833,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon": 1834,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon.svg": 1834,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app": 1835,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app.png": 1835,
	"./marketing/pages/home/ielts/sections/apps/index": 1192,
	"./marketing/pages/home/ielts/sections/apps/index.tsx": 1192,
	"./marketing/pages/home/ielts/sections/features": 1193,
	"./marketing/pages/home/ielts/sections/features/": 1193,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature": 1836,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature.png": 1836,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature": 1837,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature.png": 1837,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature": 1838,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature.png": 1838,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon": 1839,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon.svg": 1839,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature": 1840,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature.png": 1840,
	"./marketing/pages/home/ielts/sections/features/index": 1193,
	"./marketing/pages/home/ielts/sections/features/index.tsx": 1193,
	"./marketing/pages/home/ielts/sections/value_props": 1194,
	"./marketing/pages/home/ielts/sections/value_props/": 1194,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles": 1841,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles.svg": 1841,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon": 1842,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon.svg": 1842,
	"./marketing/pages/home/ielts/sections/value_props/index": 1194,
	"./marketing/pages/home/ielts/sections/value_props/index.tsx": 1194,
	"./marketing/pages/home/ielts/sections/value_props/style.module": 2296,
	"./marketing/pages/home/ielts/sections/value_props/style.module.scss": 2296,
	"./marketing/pages/home/ielts/sections/video_based_learning": 1195,
	"./marketing/pages/home/ielts/sections/video_based_learning/": 1195,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot": 1843,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot.png": 1843,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card": 1844,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card.png": 1844,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg": 1845,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg.png": 1845,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon": 1846,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon.svg": 1846,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail": 1847,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail.png": 1847,
	"./marketing/pages/home/ielts/sections/video_based_learning/index": 1195,
	"./marketing/pages/home/ielts/sections/video_based_learning/index.tsx": 1195,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module": 747,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module.scss": 747,
	"./marketing/pages/home/ielts/sections/wall_of_love": 1196,
	"./marketing/pages/home/ielts/sections/wall_of_love/": 1196,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot": 1848,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot.png": 1848,
	"./marketing/pages/home/ielts/sections/wall_of_love/index": 1196,
	"./marketing/pages/home/ielts/sections/wall_of_love/index.tsx": 1196,
	"./marketing/pages/home/ielts/style.module": 1850,
	"./marketing/pages/home/ielts/style.module.scss": 1850,
	"./marketing/pages/plans/ielts": 1597,
	"./marketing/pages/plans/ielts/": 1597,
	"./marketing/pages/plans/ielts/index": 1597,
	"./marketing/pages/plans/ielts/index.tsx": 1597,
	"./marketing/pages/plans/ielts/sections/testimonials": 1197,
	"./marketing/pages/plans/ielts/sections/testimonials/": 1197,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot": 1851,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot.png": 1851,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot": 1852,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot.png": 1852,
	"./marketing/pages/plans/ielts/sections/testimonials/index": 1197,
	"./marketing/pages/plans/ielts/sections/testimonials/index.tsx": 1197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2637;